import { Directive, EventEmitter, Input, Output } from '@angular/core';
/**
 * AgmPolylinePoint represents one element of a polyline within a  {@link
 * SembGoogleMapPolyline}
 */
var AgmPolylinePoint = (function () {
    function AgmPolylinePoint() {
        /**
         * This event emitter gets emitted when the position of the point changed.
         */
        this.positionChanged = new EventEmitter();
    }
    AgmPolylinePoint.prototype.ngOnChanges = function (changes) {
        if (changes['latitude'] || changes['longitude']) {
            var position = {
                lat: changes['latitude'].currentValue,
                lng: changes['longitude'].currentValue
            };
            this.positionChanged.emit(position);
        }
    };
    return AgmPolylinePoint;
}());
export { AgmPolylinePoint };
AgmPolylinePoint.decorators = [
    { type: Directive, args: [{ selector: 'agm-polyline-point' },] },
];
/** @nocollapse */
AgmPolylinePoint.ctorParameters = function () { return []; };
AgmPolylinePoint.propDecorators = {
    'latitude': [{ type: Input },],
    'longitude': [{ type: Input },],
    'positionChanged': [{ type: Output },],
};
//# sourceMappingURL=polyline-point.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@agm/core/directives/polyline-point.js
// module id = ./node_modules/@agm/core/directives/polyline-point.js
// module chunks = 5